import i18n from '@/i18n/i18n'
import MobileContactService from '@/services/admin/MobileContactService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = [
  'retailer_id',
  'product_id',
  'created_between',
  'by_phone_number',
  'is_done',
  'trade_type',
  'only_trashed'
]
export const allowedIncludes = 'retailer,product,unit,productUnit'
export const allowedSorts = '-created_at'

export const namespaced = true

export const state = {
  mobileContacts: null,
  mobileContact: {},
  meta: null
}
export const mutations = {
  SET_MOBILE_CONTACTS(state, mobileContacts) {
    state.mobileContacts = mobileContacts.data
    state.meta = mobileContacts.meta
  },
  SET_MOBILE_CONTACT(state, mobileContact) {
    state.mobileContact = mobileContact
  }
}

export const getters = {
  mobileContacts: state => state.mobileContacts
}

export const actions = {
  getMobileContacts({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise((resolve, reject) => {
      MobileContactService.getMobileContacts(newQuery)
        .then(response => {
          commit('SET_MOBILE_CONTACTS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.mobile_contacts.get_mobile_contacts_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getMobileContact({ commit }, id) {
    return new Promise((resolve, reject) => {
      MobileContactService.getMobileContact(id)
        .then(response => {
          commit('SET_MOBILE_CONTACT', response.data)
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  export({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise((resolve, reject) => {
      MobileContactService.export(newQuery)
        .then(response => {
          const notification = {
            type: 'info',
            message: t('store.admin.mobile_contacts.export_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.mobile_contacts.export_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  cancel({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      MobileContactService.cancelMobileContact(state.mobileContact.id)
        .then(response => {
          commit('SET_MOBILE_CONTACT', response.data)
          const notification = {
            type: 'success',
            message: t('store.admin.mobile_contacts.cancel_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.mobile_contacts.cancel_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
